import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "@/firebase";
import LoadingSpinner from "@/components/LoadingSpinner";
import Sidepanel from "@/components/Sidepanel";
import BaseInput from "@/components/BaseInput";
import "firebase/auth";

import "vue-awesome/icons/trash";
import "vue-awesome/icons/pencil-alt";
import "vue-awesome/icons/sync-alt";
import "vue-awesome/icons/user";
import "vue-awesome/icons/chart-line";
import "vue-awesome/icons/cog";
import "vue-awesome/icons/times";
import "vue-awesome/icons/check";
import "vue-awesome/icons/sign-out-alt";
import "vue-awesome/icons/cube";
import "vue-awesome/icons/stream";
import "vue-awesome/icons/eye";
import "vue-awesome/icons/file-download";

Vue.config.productionTip = false;

Vue.component("Sidepanel", Sidepanel);
Vue.component("LoadingSpinner", LoadingSpinner);
Vue.component("BaseInput", BaseInput);

import Icon from "vue-awesome/components/Icon";
Vue.component("v-icon", Icon);

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

import { createDateFilter } from "vue-date-fns";
import locale from "date-fns/locale/en";
// import { dateFilter } from "vue-date-fns";
Vue.filter("date", createDateFilter("D/M-YYYY HH:mm", { locale }));
Vue.filter("money", v =>
  v.toLocaleString("da-DK", { style: "currency", currency: "DKK" })
);
let app;

Vue.mixin({
  computed: {
    currentUser() {
      return this.$store.getters.user;
    }
  },
  methods: {
    addPanel: function(panelID, payload) {
      this.$store.dispatch("addPanel", {
        id: panelID,
        payload
      });
    },
    removeAllPanels: function() {
      this.$store.dispatch("removeAllPanels");
    },
    removePanel: function() {
      this.$store.dispatch("removePanel");
    }
  }
});

firebase.auth.onAuthStateChanged(async user => {
  if (user) {
    await store.dispatch("userLogin", user);
    if (router.currentRoute.name === "Login") router.push("/clients");
  } else {
    await store.dispatch("userLogout");
    router.push("/");
  }
  app = new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
});
